import { render, staticRenderFns } from "./recycle.vue?vue&type=template&id=69faffae&scoped=true&"
import script from "./recycle.vue?vue&type=script&lang=js&"
export * from "./recycle.vue?vue&type=script&lang=js&"
import style1 from "./recycle.vue?vue&type=style&index=1&id=69faffae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69faffae",
  null
  
)

export default component.exports